import { AxiosInstance } from 'axios';
import {
    ServiceDiscountCreate,
    ServiceDiscountFilter,
    ServiceDiscountTable,
    ServiceDiscountUpdate,
} from 'models/api/serviceDiscount';
import ResTable from 'models/api/table';
import { Key } from 'react';

const controller = '/servicediscount';

export const getServiceDiscountList = async (
    axios: AxiosInstance,
    params?: ServiceDiscountFilter
) => {
    const { data } = await axios.get<ResTable<ServiceDiscountTable>>(controller, {
        params: { ...params },
    });
    return data;
};

export const getServiceDiscountExcel = async (
    axios: AxiosInstance,
    params?: ServiceDiscountFilter
) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const getServiceDiscountItem = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.get<ServiceDiscountTable>(controller + `/${id}`);
    return data;
};

export const addServiceDiscount = async (axios: AxiosInstance, item: ServiceDiscountCreate) => {
    return await axios.post(controller, item);
};

export const updateServiceDiscount = async (axios: AxiosInstance, item: ServiceDiscountUpdate) => {
    return await axios.put(controller, item);
};

export const deleteServiceDiscount = async (axios: AxiosInstance, id: Key) => {
    return await axios.delete(controller + `/${id}`);
};
